import React from 'react'
import PropTypes from 'prop-types'

function FileRow({
  id, archive = false, notSpaced = false, children,
}) {
  return (
    <div className={`file-row ${archive ? 'file-row--archive' : ''} ${notSpaced ? 'not-spaced' : ''}`} key={`file-row-${id}`}>
      {children}
    </div>
  )
}

FileRow.propTypes = {
  id: PropTypes.string.isRequired,
  archive: PropTypes.bool,
  notSpaced: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default FileRow
